import { LoggerFactory } from '../logger';

const LOGGER = LoggerFactory.getLogger('analytics');

export default LOGGER;
